import { IconChevronRight } from '@tvg/fuse-icons';
import { buildResponsiveSize } from '@tvg/fuse-utils';
import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import styled from 'styled-components';
import { iconElementConfig } from '../../fuse-icon-element/src/icon-element';
import { TypographyComponent } from '../../fuse-typography-element/src/typography';
import titleSizeConfig from './accordion-config';

const { icon: iconSizeConfig } = titleSizeConfig;

const StyledAccordion = styled.div
	.withConfig({ shouldForwardProp: (prop) => prop !== 'hideBorder' })
	.attrs({
		className: 'fuse-accordion',
	})`
	${({ hideBorder }) => `
		border-top: ${hideBorder ? `none` : `1px solid var(--color-global-grey400)`};

		&:last-of-type {
			border-bottom: ${hideBorder ? `none` : `1px solid var(--color-global-grey400)`};
		}

		&.fuse-accordion__closed:hover {
			border-color: var(--color-brand-mid);
		}

		&.fuse-accordion__closed:hover + .fuse-accordion {
			border-top: ${hideBorder ? `none` : `1px solid var(--color-brand-mid)`};
		}
	`}
`;

const StyledAccordionHeader = styled.h3.attrs({
	className: 'fuse-accordion__header',
	'data-testid': 'fuse-accordion__header',
})``;

const StyledAccordionButton = styled.button
	.withConfig({
		shouldForwardProp: (prop) => !['titleSize', 'open'].includes(prop),
	})
	.attrs({
		className: 'fuse-accordion__button',
		'data-testid': 'fuse-accordion__button',
	})`
	${({ open, titleSize }) => {
		const setViewportCSS = buildResponsiveSize(titleSize)[1];
		const getIconSizeCSS = (viewportSize) => {
			const height = iconSizeConfig[viewportSize];

			return `
				&:after {
					flex: 0 0 ${height};
					height: ${height};
				}
		    `;
		};
		const viewportIconCSS = setViewportCSS(getIconSizeCSS);

		return `
			align-items: center;
			background: none;
			border: none;
			cursor: pointer;
			display: flex;
			padding: var(--spacing-global-space5) 0;
			text-align: left;
			width: 100%;
		
			&:focus .fuse-accordion__heading,
			&:hover .fuse-accordion__heading {
				color: var(--color-brand-mid);
			}
		
			&:focus:after,
			&:hover:after {
				background: var(--color-brand-mid);
			}
		
			&:focus-visible,
			&:active {
				outline: var(--spacing-global-space1) solid var(--color-functional-focus);
			}
		
			&:focus:not(:focus-visible) {
				outline: none;
			}
		
			&:after {
				content: '';
				display: inline-flex;
				flex: 0 0 ${iconElementConfig.small.height};
				height: ${iconElementConfig.small.height};
				mask: url('data:image/svg+xml,${encodeURIComponent(renderToStaticMarkup(<IconChevronRight />))}')
					center/cover no-repeat;
				-webkit-mask: url('data:image/svg+xml,${encodeURIComponent(
		renderToStaticMarkup(<IconChevronRight />),
	)}')
					center/cover no-repeat;
				background: var(--color-global-black);
				transform: rotate(${open ? '-90deg' : '90deg'});
				transition-duration: 300ms;
			}
		
			/* Overriding flex-basis and height of icon pseudo element in button based on different viewports */
			${viewportIconCSS}
		`;
	}}
`;

const StyledAccordionHeading = styled(TypographyComponent)
	.withConfig({ shouldForwardProp: (prop) => prop !== 'chevronInline' })
	.attrs({
		className: 'fuse-accordion__heading',
		'data-testid': 'fuse-accordion__heading',
	})`
	flex: ${({ chevronInline }) => (chevronInline ? `unset` : `1 1 auto`)};
	margin-right: var(--spacing-global-space3);
`;

const StyledAccordionContent = styled.div.attrs({
	className: 'fuse-accordion__content',
	'data-testid': 'fuse-accordion__content',
})`
	padding-bottom: var(--spacing-global-space6);

	&.fuse-acccordion__content--hide {
		display: none;
	}
`;

export {
	StyledAccordion,
	StyledAccordionButton,
	StyledAccordionContent,
	StyledAccordionHeader,
	StyledAccordionHeading,
};
